<template>
  <div class="flex gap-1 nested-menu-tab-button-container">
    <nested-menu-tab-button :title="$tc('consultation', 2)" icon="icon-list" route="consultations.consultations"></nested-menu-tab-button>
    <template v-if="isManager || $store.getters.hasPermission('call_back')">
      <nested-menu-tab-button :title="$t('callbacks')" icon="icon-phone" route="consultations.callbacks"></nested-menu-tab-button>
    </template>
    <template v-if="isManager">
      <nested-menu-tab-button :title="$t('import_consultations')" icon="icon-upload" route="consultations.import"></nested-menu-tab-button>
    </template>
  </div>
</template>

<script>
import NestedMenuTabButton from '@/components/navigations/NestedMenuTabButton'

export default {
  name: 'Shared.Consultations.TabNav',
  components: {
    NestedMenuTabButton
  },
  data () {
    return {
      isManager: ''
    }
  },
  mounted () {
    this.isManager = this.$store.getters.isManager
  }
}
</script>

<style scoped>

</style>
